import Vue from 'vue';
import Vuex from 'vuex';
import { alert } from './alert';
import { firmware } from './firmware';
import { device } from './device';
import { loading } from './loading';
import { login } from './login';
import { RootState } from './types';

Vue.use(Vuex);

export default new Vuex.Store<RootState>({
  state: {
    version: '1.0.0',
    menuVisible: false,
  },
  modules: {
    login,
    device,
    firmware,
    alert,
    loading,
  },
  mutations: {
    toggleMenu: (state) => {
      state.menuVisible = !state.menuVisible;
    },
    closeMenu: (state) => {
      state.menuVisible = false;
    },
    openMenu: (state) => {
      state.menuVisible = true;
    },
  },
  actions: {},
});
